import { gsap } from "gsap";

export default class TabbarHandler {
	init() {
		gsap.utils.toArray('[data-tab-bar="container"]').forEach((container) => {
			const button = container.querySelector('[data-tab-bar="button"]');
			const tabs = container.querySelectorAll('button');
			// Find the initially active tab or default to first
			let activeTab = container.querySelector('button.active') || tabs[0];

			// Function to get current container measurements
			const getContainerMeasurements = () => {
				return {
					rect: container.getBoundingClientRect(),
					padding: parseInt(getComputedStyle(container).paddingLeft)
				};
			};
			
			// Function to position button to a specific tab
			const positionButtonToTab = (tab, duration = 0) => {
				const { rect: containerRect, padding: containerPadding } = getContainerMeasurements();
				const tabRect = tab.getBoundingClientRect();
				gsap.to(button, {
					x: tabRect.left - containerRect.left - containerPadding,
					width: tabRect.width,
					height: tabRect.height,
					duration: duration,
					ease: duration > 0 ? "power2.out" : "none"
				});
			};
			
			// Set initial position to active tab
			if (activeTab) {
				positionButtonToTab(activeTab);
			}
			
			// Add hover and click listeners to each tab
			tabs.forEach((tab) => {
				tab.addEventListener('mouseenter', () => {
					positionButtonToTab(tab, 0.5);
				});
				
				tab.addEventListener('mouseleave', () => {
					// Only reset if this tab is not the active one
					if (tab !== activeTab) {
						// Return to active tab position
						positionButtonToTab(activeTab, 0.5);
					}
				});
				
				tab.addEventListener('click', () => {
					const tabIndex = Array.from(tabs).indexOf(tab);
					
					// Set new active tab
					activeTab = tab;
					// Move button to clicked tab
					positionButtonToTab(tab, 0.5);
					
					// Emit custom event for target elements to listen to
					const target = container.getAttribute('data-target');
					if (target) {
						const targetElement = document.querySelector(`[data-custom-pagination="${target}"]`);
						if (targetElement) {
							targetElement.dispatchEvent(new CustomEvent('tabChanged', {
								detail: { index: tabIndex, tab: tab }
							}));
						}
					}
				});
			});
			
			// Add resize handler to recalculate positions
			const resizeHandler = () => {
				positionButtonToTab(activeTab);
			};
			
			window.addEventListener('resize', resizeHandler);
		});
	}
}